import React, { useState } from "react";
import { Button, Popover, Input, Form, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const { Paragraph } = Typography;

function isValidUrl(url) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

function NewRecipePopover() {
  const [visible, setVisible] = useState(false);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");
  const navigate = useNavigate();

  const backendUrl = process.env.REACT_APP_BACKEND_URL || "";

  const handleAddRecipe = async () => {
    setErrorText("");
    if (url && isValidUrl(url)) {
      setLoading(true);
      try {
        const res = await axios.post(
          `${backendUrl}/ai/recipe-url`,
          { aiurl:url },
          { withCredentials: true }
        );
        const data = res.data;
        if (data && data.id) {
          setVisible(false);
          navigate(`/ui/recipe/${data.id}`);
        } else {
          setErrorText("Could not create recipe from the provided URL.");
        }
      } catch (err) {
        setErrorText("Error contacting API.");
      } finally {
        setLoading(false);
      }
    } else if (!url) {
      setVisible(false);
      navigate("/ui/recipe/");
    } else {
      setErrorText("Please enter a valid URL or leave the field empty.");
    }
  };

  const popoverContent = (
    <div style={{ maxWidth: 320, padding: 4 }}>
      <Paragraph>
        <b>Instructions:</b> To create a new recipe, either post a URL or click <b>Add</b> to start from scratch.
      </Paragraph>
      <Form layout="vertical" onFinish={handleAddRecipe}>
        <Form.Item label="URL" validateStatus={errorText ? "error" : ""} help={errorText || ""}>
          <Input
            placeholder="Enter recipe URL"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            autoFocus
            disabled={loading}
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block disabled={loading}>
            {loading ? <Spin indicator={<LoadingOutlined spin />} /> : "Add Recipe"}
          </Button>
        </Form.Item>
      </Form>
      <Paragraph style={{ marginBottom: 0, fontSize: 12, color: "#888" }}>
        Or leave URL blank to start from scratch.
      </Paragraph>
    </div>
  );

  return (
    <Popover
      placement="bottomRight"
      content={popoverContent}
      trigger="click"
      open={visible}
      onOpenChange={setVisible}
      destroyTooltipOnHide
    >
      <Button type="primary" style={{ boxShadow: "0 2px 0 0 #357a1f" }}>
        New Recipe
      </Button>
    </Popover>
  );
}


export default NewRecipePopover;